module.exports = __webpack_public_path__ + "media/hallBgm.d1c92273.mp3";